import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_Speaker } from 'ui/components/1-atoms/Speaker/Speaker';
import Script from 'next/script';
import { useRouter } from 'next/router';

interface Props {
	background?: 'Primary';
	noBottomSpacing?: boolean;
}

export const Speaker = ({ background, noBottomSpacing }: Props) => {
	const dictionary = useDictionaryContext();
	const speakerAloudText = dictionary.getAction('ReadAloud');
	const { locale } = useRouter();

	const language = locale as unknown as 'da' | 'kl-gl';
	const isEnabled = language.toLowerCase() == 'da' || language.toLowerCase() == 'kl-gl';
	return isEnabled ? (
		<>
			<Script src="https://oqaasileriffik.gl/d/martha.js" strategy="afterInteractive" />
			<UI_Speaker background={background} noBottomSpacing={noBottomSpacing} speakerAloudText={speakerAloudText} />
		</>
	) : null;
};
